import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { GoogleMap, MapMarker } from '@angular/google-maps';
import { TranslateModule } from '@ngx-translate/core';
import { CheckboxComponent } from '../../../../../osp-ui/components/checkbox/checkbox.component';
import { ErrorComponent } from '../../../../../osp-ui/components/form/form-field/components/error/error.component';
import { LabelComponent } from '../../../../../osp-ui/components/form/form-field/components/label/label.component';
import { FormFieldComponent } from '../../../../../osp-ui/components/form/form-field/form-field.component';
import { InputTextComponent } from '../../../../../osp-ui/components/form/input-text/input-text.component';
import { LocationSearchInputComponent } from '../../../../../shared/components/maps/components/location-search-field/location-search-field.component';
import { MapSearchPlaceResult } from '../../../../../shared/components/maps/contract/map-search-place-result.contract';
import { MapDefaultOptionsDirective } from '../../../../../shared/components/maps/directives/map-default-options.directive';

@Component({
  selector: 'osp-location-address-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    GoogleMap,
    MapMarker,
    MapDefaultOptionsDirective,
    LocationSearchInputComponent,
    FormFieldComponent,
    LabelComponent,
    InputTextComponent,
    ErrorComponent,
    CheckboxComponent,
  ],
  templateUrl: './location-address-form.component.html',
  styleUrls: ['./location-address-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LocationAddressFormComponent {
  @Input({ required: true }) formGroup!: FormGroup;
  @Input({ required: true }) mapCenter!: google.maps.LatLngLiteral;
  @Input() mapMarkerPosition: google.maps.LatLngLiteral | null = null;
  @Input() isMapLoaded = false;
  @Input() showAutomaticGeofence = false;

  @Output() readonly mapClick = new EventEmitter<google.maps.MapMouseEvent>();
  @Output() readonly locationChanges = new EventEmitter<MapSearchPlaceResult>();
}
